module.exports = __webpack_public_path__ + "static/img/2-1.f796c0e2.png";